import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { fetchBusinessEstimateApi } from '~/api';
import { DEFAULT_ESTIMATE } from '~/constants/defaultStates';
import { useBoolean } from '~/hooks/useBoolean';
import { useSelector } from '~/store';
import { selectBusinessUuid } from '~/store/slices/formSlice/selectors';
import { IEstimateSerializer } from '~/types/estimate';
import { ApiResponseEnum, apiResponseHandler } from '~/utils/api';

export function useEstimateDetails(estimateUuid: string | null) {
  const [isLoading, loadingActions] = useBoolean();
  const [estimateData, setEstimateData] = useState<IEstimateSerializer>({ ...DEFAULT_ESTIMATE });
  const businessUuid = useSelector(selectBusinessUuid);

  async function getEstimateData() {
    if (!estimateUuid || !businessUuid) {
      setEstimateData({ ...DEFAULT_ESTIMATE });
      return;
    }
    loadingActions.on();
    const promise = await fetchBusinessEstimateApi(businessUuid, estimateUuid);
    const response = await apiResponseHandler<IEstimateSerializer>(promise);
    if (response.type === ApiResponseEnum.Success) {
      setEstimateData(response.data);
    } else {
      toast.error('Failed to fetch Estimate data');
    }
    loadingActions.off();
  }

  useEffect(() => {
    getEstimateData();
  }, [estimateUuid, businessUuid]);

  return {
    isLoading,
    estimateData,
  };
}
